<template>
  <div class="ft-page">
    <div class="ft-shell flex min-h-screen flex-col justify-center py-10 lg:py-16">
      <header class="mb-10 flex items-center justify-between animate-fade-up">
        <div class="flex items-center gap-3">
          <img :src="url" alt="batalgaa.mn" class="h-11 w-11 rounded-xl object-cover ring-1 ring-mist-line" />
          <span class="ft-brand">batalgaa.mn</span>
        </div>
        <a
          href="tel:+97699700020"
          class="hidden items-center gap-2 rounded-full border border-mist-line bg-white/80 px-4 py-2 text-sm font-semibold text-ink backdrop-blur sm:inline-flex"
        >
          <span class="h-2 w-2 rounded-full bg-mint-bright animate-soft-pulse" />
          +976 9970 0020
        </a>
      </header>

      <div class="grid items-center gap-10 lg:grid-cols-12 lg:gap-14">
        <section class="lg:col-span-7 animate-fade-up-delay">
          <p class="mb-4 text-sm font-semibold uppercase tracking-[0.18em] text-mint">
            Банкны баталгаа · Fintech
          </p>
          <h1 class="font-display text-4xl font-bold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-[3.4rem]">
            Визийн баталгаа.<br />
            <span class="text-mint">Итгэлцэлтэй</span> санхүүжилт.
          </h1>
          <p class="mt-5 max-w-xl text-base leading-relaxed text-ink-muted sm:text-lg">
            Бүх улсын визэнд зориулсан банкны баталгаа тодорхойлолт болон сургалтын төлбөрийн зээлийн
            хүсэлтийг хурдан, ил тод бүртгэнэ.
          </p>

          <div class="mt-8 grid max-w-lg grid-cols-3 gap-3">
            <div class="ft-metric">
              <div class="ft-metric-label">Үйлчилгээ</div>
              <div class="ft-metric-value text-base">Баталгаа</div>
            </div>
            <div class="ft-metric">
              <div class="ft-metric-label">Хариу</div>
              <div class="ft-metric-value text-base">Түргэн</div>
            </div>
            <div class="ft-metric">
              <div class="ft-metric-label">Дэмжлэг</div>
              <div class="ft-metric-value text-base">24/7</div>
            </div>
          </div>
        </section>

        <section class="lg:col-span-5 animate-fade-up-delay-2">
          <div class="ft-panel relative overflow-hidden p-6 sm:p-8">
            <div class="pointer-events-none absolute -right-10 -top-10 h-36 w-36 rounded-full bg-mint-soft" />
            <div class="pointer-events-none absolute -bottom-12 -left-8 h-28 w-28 rounded-full bg-gold-soft" />

            <div class="relative">
              <h2 class="font-display text-xl font-bold text-ink">Хүсэлт үлдээх</h2>
              <p class="mt-1 text-sm text-ink-muted">Мэргэжилтэн тантай удахгүй холбогдоно.</p>

              <el-form
                class="mt-6 text-left"
                :model="form"
                :rules="rules"
                ref="registrationForm"
                label-position="top"
              >
                <el-form-item label="Нэр" prop="first_name">
                  <el-input v-model="form.first_name" placeholder="Та нэрээ оруулна уу" clearable />
                </el-form-item>

                <el-form-item label="Утас" prop="phone">
                  <el-input v-model="form.phone" v-numpad="'tel'" placeholder="8 оронтой утасны дугаар" maxlength="8" clearable />
                </el-form-item>

                <el-form-item class="!mb-3">
                  <button
                    type="button"
                    class="ft-btn-primary w-full"
                    @click="submitForm('registrationForm')"
                  >
                    Бүртгүүлэх
                  </button>
                </el-form-item>
              </el-form>

              <div class="mt-4 grid grid-cols-2 gap-3">
                <a href="tel:+97699700020" class="ft-btn-secondary w-full text-center">
                  Холбоо барих
                </a>
                <a
                  href="https://www.messenger.com/t/100092603605940"
                  target="_blank"
                  rel="noopener"
                  class="ft-btn-secondary w-full text-center"
                >
                  Чат
                </a>
              </div>

              <p class="mt-5 text-center text-xs text-ink-muted">
                Зээлийн хүсэлт бөглөх бол
                <router-link to="/about" class="font-semibold text-mint hover:underline">
                  энд дарна уу
                </router-link>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>

    <loader-item :isLoader="$root.fullscreenLoading" />
  </div>
</template>

<script>
import LoaderItem from '@/components/loader/loader-item.vue'
import logo from '@/assets/batalgaa.mn_logo.png'
import services from '@/helpers/services.js'

export default {
  components: {
    LoaderItem
  },
  data () {
    return {
      url: logo,
      form: {
        first_name: '',
        phone: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        first_name: [
          { required: true, message: 'Уучлаарай та нэрээ оруулна уу', trigger: 'blur' },
          { min: 1, max: 50, message: 'Таны нэр 1 -аас 50 тэмдэгт байх шаардлагатай.', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Та утасны дугаараа оруулна уу', trigger: 'blur' },
          { pattern: /^[0-9]{8}$/, message: 'Таны утасны дугаар буруу байна. 8 оронтой байх шаардлагатай.', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    validatePassword (rule, value, callback) {
      if (value !== this.form.password) {
        callback(new Error('Passwords do not match'))
      } else {
        callback()
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$root.fullscreenLoading = true
          services.createUser(this.form)
            .then((response) => {
              if (response.status === 'success') {
                this.$root.fullscreenLoading = false
                this.$alert('Танд баярлалаа манай ажилтан тантай тун удахгүй холбоо барих болно.?', 'Амжилттай', {
                  confirmButtonText: 'Баярлалаа',
                  type: 'success'
                }).then(() => {
                  location.reload()
                }).catch(() => {})
              }
            })
        } else {
          this.$notify.error({
            title: 'Алдаа гарлаа',
            message: 'Та мэдээлэл дутуу эсэхийг шалгаарай.'
          })
          return false
        }
      })
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  }
}
</script>
